var totalLandingCount = 2;
$(document).ready(function () {
  AndroidZoomDisabled();
  mobile();
  filter();
  checkCookiesWithReffer()
  header_active();
  detailchange();
  movescroll();
  contactus();
  footer();
  changemode();
  // offfocus(); 
  breakpoint();
  wkSignin();
  textReplace();
  scrollCp();
  subscribeAfter();

  
  var waitForEl = function(selector, callback) {
    if (jQuery(selector).length) {
      callback();
    } else {
      setTimeout(function() {
        waitForEl(selector, callback);
      }, 100);
    }
  };

  waitForEl(".rk-widget-container", function() {
   afterLoad();
  });
  
  waitForEl(".wk-signin", function() {
    wkSignin()
  });

  
});

// $(window).bind("pageshow", function(event) {
//   if (event.originalEvent.persisted) {
//     document.location.reload();
//   }
// });



// $(window).on("load",function(){
  // Animate loader off screen
//   $("body").css("overflow","scroll");
//   $(".loadding-collection").fadeOut("slow");
// });

function subscribeAfter(){
  $(".shopify-email-marketing-confirmation__container a").attr("href","../").text("GO HOME");
}


function scrollCp(){
  var _scrollX = $(".breadcrumb-wrap .breadcrumb .breadcrumb_link.sub_nav").scrollLeft();
  var cpNum = $(".breadcrumb-wrap .breadcrumb .breadcrumb_link.sub_nav ul li.highlight").index();
  var tt = cpNum * 18
  if(cpNum >3){
    $(".breadcrumb-wrap .breadcrumb .breadcrumb_link.sub_nav").scrollLeft(109);
//     console.log(tt)
  }
}

function AndroidZoomDisabled(){
  var userAgent = navigator.userAgent;
  var smartPhones = new Array('iPhone','iPad','SAMSUNG','BlackBerry','Android','Windows CE','Windows CE;','LG','MOT','SonyEricsson','Symbian','Opera Mobi','Opera Mini','IEmobile');
  var mobileKeyWords = new Array('SAMSUNG','BlackBerry','Android','Windows CE','Windows CE;','LG','MOT','SonyEricsson','Symbian','Opera Mobi','Opera Mini','IEmobile');
  var IE = new Array('MSIE', 'IEmobile');
  var windowsize = $(window).width();
  for(var word in mobileKeyWords){
    if(navigator.userAgent.match(mobileKeyWords[word])!=null){
      if(windowsize < 768){
        $("body").addClass("device");
        $("#header-content").addClass("device");
        break;
      }
    }
  }
  
   for(var word2 in smartPhones){ 
    if(navigator.userAgent.match(smartPhones[word2])!=null){
      if($("body").hasClass("template-product")){
        $("body.template-product .share_wrap").addClass("line");
        break;
      }
    }
  }
  
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");
  
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
  {
    $("body").addClass("IEview");
    $(".notice_overlay").addClass("active");  
  }
  else  // If another browser, return 0
  {
//     $("body").addClass("IEview");
//     $(".notice_overlay").addClass("active");
    $("body").removeClass("IEview");
  }

  return false;

  
}


function afterLoad(){
  // arrow
  $(".rk-widget-container button.glide__arrow").addClass("cs-font");
  $(".rk-widget-container button.glide__arrow.glide__arrow--left").attr("data-glide-dir","");

  $(".rk-widget-container button.glide__arrow.glide__arrow--right").attr("data-glide-dir",">");


  $(".rk-widget-card").each(function(){
    var target = $(this).find(".rk-widget-card-image-wrap");
    var src = $(this).find("img").attr("src");
    var newSrc;

    // title
    var $title = $(this).find(".rk-widget-card-title-text").text();

    if($title.indexOf("BASIC") > 0){
      $title = $title.replace(" BASIC","<br>BASIC");
    }else if($title.indexOf("ICONIC") > 0){
      $title = $title.replace(" ICONIC","<br>ICONIC");
    }else if($title.indexOf("SOLID") > 0){
      $title = $title.replace(" SOLID","<br>SOLID");
    }else if($title.indexOf("COLOR") > 0){
      $title = $title.replace(" COLOR","<br>COLOR");
    }else if($title.indexOf("HERRINGBONE") > 0){
      $title = $title.replace(" HERRINGBONE","<br>HERRINGBORN");
    }else if($title.indexOf("HOUND") > 0){
      $title = $title.replace(" HOUND","<br>HOUND");
    }else if($title.indexOf("DIPTYCH") > 0){
      $title = $title.replace(" DIPTYCH","<br>DIPTYCH");
    }else if($title.indexOf("BURNED") > 0){
      $title = $title.replace(" BURNED","<br>BUREND");
    }else if($title.indexOf("DUPLE") > 0){
      $title = $title.replace(" DUPLE","<br>DUPLE");
    }else if($title.indexOf("DUO") > 0){
      $title = $title.replace(" DUO","<br>DUO");
    }else if($title.indexOf("CHIFFON") > 0){
      $title = $title.replace(" CHIFFON","<br>CHIFFON");
    }else if(n.title.indexOf("CHECK") > 0){
      $title = $title.replace(" CHECK","<br>CHECK");
    }

    $(this).find(".rk-widget-card-title-text").html($title);


    // swatch img
  })
    
  
  $(".glide__arrow--right").click(function(){
    count+=1;
    
    var dir = $(this).attr("data-glide-dir");
    var newDir;
    
    
    newDir = "="+ count
    $(this).attr("data-glide-dir",newDir);
    console.log(dir)
  })
}



$(window).on("beforeunload", function(e) {
  $.cookie("reload",new Date().getTime()+1000);
});


function checkCookiesWithReffer() {
  if (!$("body").hasClass("template-index")) {
    return;  
  }
  if( parseInt($.cookie("reload")) > new Date().getTime() ) {
    setLandingImage(parseInt($.cookie("nLandingNo")));

//     console.log("reloaded");
    return ;
  }

  var bEnteredFromOtherTab = document.referrer.indexOf("cosa") > -1;

  var nLandingNo = parseInt($.cookie("nLandingNo"));

  //한번도 방문하지 않았던 유저는 expireTime과 nLandingNo값이 없으므로 세팅해주운다~
  if (typeof nLandingNo === 'undifined' || nLandingNo == null || isNaN(nLandingNo) ) {
    console.log("cookie initialized");
    $(".main-content .main_container > div").eq(1).css("display", "none");
    colorchange();
    $.cookie("nLandingNo", 0);
    return;
  }

  if ( bEnteredFromOtherTab ) {
    setLandingImage(nLandingNo);
    return;
  }

  $.cookie("nLandingNo", (nLandingNo + 1) % totalLandingCount);

  nLandingNo = parseInt($.cookie("nLandingNo"));
  setLandingImage(nLandingNo);
}



function setLandingImage(nLandingNo) {
  switch (nLandingNo) {
    case 0 :
      $(".main-content .main_container > div").eq(1).css("display", "none");
      colorchange();
      $("body").addClass("mainBlack");
      hdBlack();
      break;
    case 1 :
      $(".main-content .main_container > div .slideshow-wrapper").eq(0).css("display", "none"); 
      $(".main-content .main_container > div").eq(1).find(".bb_maintxt_container").css("display", "none");
      $(".template-index #header-mobile .logo-sticky .mlogow").css("display","none");
      $(".template-index #header-mobile .logo-sticky .mlogob").css("display","block");
      $("body").addClass("mainBlack");
      hdBlack();
      break;
  }
}

function filter(){
  if (!$("body").hasClass("template-collection")) {
    return;
  }
  $("button.filter_title").click(function(){
    $(this).parent().find("div.content").slideToggle();
    $(this).toggleClass("filteractive");  
  });
}

function mobile(){
  var $window = $(window);
  function checkWidth() {
    var windowsize = $window.width();

    if (windowsize >= 1024) {
      if(!$("body").hasClass("template-index")){
      

        $(".site-nav > li").hover(function(){
          $(".header_overlay").fadeIn();

          $(".header_overlay").click(function(){
            $(this).fadeOut();
          });
          $(".header_overlay").hover(function(){
            $(this).fadeOut();
          });
        },function(){
          $(".header_overlay").fadeOut();
        });
      }
      
    }

    if( windowsize < 1024){   
      $("body").addClass("tablet");
    }else{
      $("body").removeClass("tablet");
    }

    if( windowsize == 1080){   
//       $("body").addClass("tablet");
    };

    
    if (windowsize < 767) {
      //if the window is greater than 440px wide then turn on jScrollPane..
      $("body").addClass("mobile");
    }else{
      $("body").removeClass("mobile");
    }

  }
  // Execute on load
  checkWidth();
  // Bind event listener
  $(window).resize(checkWidth);
}

// Landing page - text color change
function colorchange(){
  if(!$("body").hasClass("template-index")){
    return;
  };

  if(($("body").hasClass("tablet"))||($("body").hasClass("mobile"))){
    $(".bb_maintxt_container .bb_maintxt_list li").mouseover(function(){
      var Eq = $(this).index();
      if(Eq == 3){
        hdBlack();
        $("body").addClass("mainBlack");
      }else{
        hdWhite();
        $("body").removeClass("mainBlack");
      }
    })
  }else{
    $(".bb_maintxt_container .bb_maintxt_list li").mouseover(function(){

      if($(".main-content .main_container > div").eq(1).find(".bb_maintxt_container").css("display")== "none"){
        hdBlack();
        $("body").addClass("mainBlack");
      }else{
        var Eq = $(this).index();
        if(Eq%2 == 0){
          hdWhite();
          $("body").removeClass("mainBlack");
        }else{
          hdBlack();
          $("body").addClass("mainBlack");
        };
      }

    });
  }

};


function header_active(){
  
  var height;
  var top = $(".dropdown-sub").offset().top;

  $(".dropdown-sub").hover(function(){
    $(".template-index .header-absolute").addClass("hon");
    $(".template-index #header-content").addClass("hon");
    
  },function(){
    setTimeout(function(){
      $(".template-index .header-absolute").removeClass("hon");
    },320);

    setTimeout(function(){
    },500);



  });

  $(".site-nav .dropdown-sub").hover(function(){
    var $prev = $(this).prevAll(".dropdown-toggle");
    var $underlineTarget = $prev.children().first();
    $underlineTarget.addClass("headerOn");

  },function(){
    var $prev = $(this).prevAll(".dropdown-toggle");
    var $underlineTarget = $prev.children().first();
    // $underlineTarget.removeClass("headerOn");
  }); 


};


// header menu font color black
function hdBlack(){ 
  var $header = $(".template-index .header-absolute.white #header-content .header-inner .site-nav .level-top > a");
  var $rtmenu = $(".sticky p.header-rt-menu");
  var $rticon = $(".template-index .header-absolute.white .search-top-container .icon-search i");
  var $rtheart = $(".template-index .header-absolute.white .top-currency .dropdown-icon i");
  var $maintxt = $(".bb_maintxt_container .bb_maintxt_list li");
  var $logo = "//cdn.shopify.com/s/files/1/0042/3975/3283/files/logo_2x_438aa16c-97d5-4733-9bc0-62985f4a6be8_2048x.png?v=1546493778";
  var $logoB = $("#header-content .logo-sticky img").attr("src");
  var $logoC = "//cdn.shopify.com/s/files/1/0213/5710/1156/files/logo2_2048x.png?v=1548060582";
  var underline = $(".bb_maintxt_container .bb_maintxt_list li:hover::after");
  var cartcount= $(".header-cart .top-cart .cart-count");
  var $hambmenu = $("#header-mobile .navbar-toggle i");
  var $carticon = $("#header-mobile .top-cart i");

  $header.css({color: "#1a1919"});
  $maintxt.css({color: "#1a1919"});
  $rtmenu.css({color: "#1a1919"});
  $rticon.css({color: "#1a1919"});
  $rtheart.css({color: "#1a1919"});
  cartcount.css({color: "#1a1919"});
  $("#header-content .logo img").attr("src",$logoB);
  $("#header-mobile .logo-sticky img").attr("src",$logoC);
  underline.css({"background-color": "#1a1919"});
  $hambmenu.css({color: "#1a1919"});
  $carticon.css({color: "#1a1919"});

};



// header menu font color white
function hdWhite(){
  var $header = $(".template-index .header-absolute.white #header-content .header-inner .site-nav .level-top > a");
  var $rtmenu = $(".sticky p.header-rt-menu");
  var $rticon = $(".template-index .header-absolute.white .search-top-container .icon-search i");
  var $rtheart = $(".template-index .header-absolute.white .top-currency .dropdown-icon i");
  var $maintxt = $(".bb_maintxt_container .bb_maintxt_list li");
  var $logo = "//cdn.shopify.com/s/files/1/0042/3975/3283/files/logo_2x_438aa16c-97d5-4733-9bc0-62985f4a6be8_2048x.png?v=1546493778";
  var underline = $(".bb_maintxt_container .bb_maintxt_list li:hover::after");
  var cartcount= $(".header-cart .top-cart .cart-count");
  var $hambmenu = $("#header-mobile .navbar-toggle i");
  var $carticon = $("#header-mobile .top-cart i");

  $header.css({color: "#ffffff"});
  $maintxt.css({color: "#ffffff"});
  $rtmenu.css({color: "#ffffff"});
  $rticon.css({color: "#ffffff"});
  $rtheart.css({color: "#ffffff"});
  cartcount.css({color: "#ffffff"});
  $("#header-content .logo img").attr("src",$logo);
  $("#header-mobile .logo-sticky img").attr("src",$logo);
  underline.css({"background-color": "#ffffff"});
  $hambmenu.css({color: "#ffffff"});
  $carticon.css({color: "#ffffff"});

};



function full_page(){
  if($("body").attr("id")== "brand-story"){
    $(".container").css("margin-right","0 !important");
  };
};



// product detail page - change description
function detailchange(){  
  if(!$("body").hasClass("template-product")){
    return;
  };

  var check = $("div.product-shop .product-title h1").html();
  var large = "L <br>";
  var small = "S <br>";
  var li = $("#accordion2 .panel-default #collapse5 p");
  var text = li.eq(1).html();
  var text2 = li.eq(9).html();
  var text3 = li.eq(4).html();
  var res,
      res2,
      res3 = null;

  if(check.includes("COMPAGNIA")){
    if(check.includes("DUO")){
      res = text.replace("4cm","2.5cm")
      res3 = text3.replace("1.3cm","1cm");
    }else if(check.includes("DUPLE")){
      res = text.replace("4cm","2cm / 3cm")
      res3 = text3.replace("1.3cm","1cm / 1.3cm");
    }
    res2 = text2.replace("Specially crafted magnetic Coin","Two specially crafted magnetic Coins");

  }else{  
    if(check.includes(large)){
      if(check.includes("BLANC")){
        res = text.replace("4cm","4.5cm");
      }else{
        res = text.replace("4cm","5cm");
      }
    }else if(check.includes(small)){
      res = text.replace("4cm","2.5cm");
    }
    res2 = text2.replace("Two lapel flowers","Lapel flower");
  };

  li.eq(1).html(res);
  li.eq(9).html(res2);
  li.eq(4).html(res3);
  

};


// collection pages - click text, move scroll
function movescroll(){
  //   if(!$("body").attr("id").includes("collection")){
  //     return;
  //   };
  var $all = $("#all-collections .allcol_header .allcol_hd_content .allcol_hd_list li");
  var $cp = $("#cosa-piora-collection .cpcol_header .cpcol_hd_content .cpcol_hd_list li");
  var $size = $("#size-guide .care_lt .care_menu .care_list li");
  var $style = $("#style-fit .care_lt .care_menu .care_list li");
  var $wrap = $(".allcol_wrap");
  var $sizewrap = $(".care_rt .care_part_title");
  var $stylewrap = $(".care_rt > .care_part_title");

  if($("body").hasClass("mobile")||$("body").hasClass("tablet")){
    $($all).click(function() {
      var count = $(this).index();
      $('html,body').animate({
        scrollTop: ($wrap.eq(count).offset().top-80)},'slow');
    });

    $($cp).click(function() {
      var count = $(this).index();
      $('html,body').animate({
        scrollTop: ($wrap.eq(count).offset().top-200)},'slow');
      
    });

    $($size).click(function() {
      var count = $(this).index();
      //     if(count != 0)
      $('html,body').animate({
        scrollTop: ($sizewrap.eq(count).offset().top-200)},'slow');
    });
    
    
    
    $($style).click(function() {
      var count = $(this).index();
      //     if(count != 0)
      $('html,body').animate({
        scrollTop: ($stylewrap.eq(count).offset().top-200)},'slow');
    });


  }else{
    $($all).click(function() {
      var count = $(this).index();
      $('html,body').animate({
        scrollTop: ($wrap.eq(count).offset().top-96)},'slow');
    });

    $($cp).click(function() {
      var count = $(this).index();
      $('html,body').animate({
        scrollTop: ($wrap.eq(count).offset().top-200)},'slow');
    });

    $($size).click(function() {
      var count = $(this).index();
      
//       if($(this).hasClass("flower_nav")){
//         count = count-1;
//       }
      $('html,body').animate({
        scrollTop: ($sizewrap.eq(count).offset().top-200)},'slow');
    });
    
     $($style).click(function() {
      var count = $(this).index();
      //     if(count != 0)
      $('html,body').animate({
        scrollTop: ($stylewrap.eq(count).offset().top-200)},'slow');
    });

  }
}

// contact us page - contact information text show and hide
function contactus(){
  if(!$("body").attr("id") == "contact-us"){
    return;
  };

  $(".contactus-page .contact_rt #accordion2 a.collapsed").click(function(){
    var $id = $(this).attr("id");
    $(this).children().eq(1).toggleClass("show");
  });
};


function headercart(){
  $("#header-content #header-cart-on").on("click",function(){
    $('#dropdown-cart').addClass('active');
    $('.wrapper-container').addClass('show-cart');
  });
}



function offfocus(){

  var mobileKeyWords = new Array('iPhone','iPad','SAMSUNG','BlackBerry','Android','Windows CE','Windows CE;','LG','MOT','SonyEricsson','Symbian','Opera Mobi','Opera Mini','IEmobile');
  var inputs = jQuery("input");
  for(var word in mobileKeyWords){
   if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
      
     if($("body").attr("id") == "addresses"){
       return;
     }else{
       $("body img").css("image-rendering", "auto");
       $(document).on('touchstart','body', function (evt) {
         var targetTouches = event.targetTouches;
         if ( !inputs.is(targetTouches) && !jQuery(evt.target).hasClass('snize-mobile-input-style')){
           inputs.context.activeElement.blur();
         }
       });
     }
    }
    if(navigator.userAgent.match(/(SAMSUNG|Android|LG)/)){
      $("body").addClass("android");
    }
    
    if(navigator.userAgent.match(/(Mac)/)){
      $("body").addClass("mac");
    }
    
  }
}

function breakpoint(){
  var allcol = "The Final Touch to your<br>Bespoke Lifestyle";
  var bravado = "Courage and Confidence<br>to Accomplish";
  var blanc = "Symbol of Devotion,<br>and Purity of Heart";
  var terms = 'Terms<span class="crumbsm">&</span><br>Conditions';
  var privacy = 'Privacy<span class="crumbsm">&</span><br>Cookies&thinsp;&thinsp;&thinsp;';
  var rispetto = 'Dignified presence. Deep hues in the finest, supple materials with a subdued sheen. The petals bend with ease, to the wind or a step, but always stay in place. They signify the respect we grant others, and the respect we attain for ourselves.';
  
  var glorio = $("#glorio .breadcrumb-wrap .breadcrumb .breadcrumb_description p:last-child").text();
  var brama = $("#cosa-brama .breadcrumb-wrap .breadcrumb .breadcrumb_description p:last-child").text();
  var blanc2 = $("#cosa-blanc .breadcrumb-wrap .breadcrumb .breadcrumb_description p:last-child").text();

  
  
  glorio = glorio.replace("dence.","dence. ");
  brama = brama.replace("sheen.","sheen. ");
  blanc2 = blanc2.replace("With"," With");
 

  // mobile
  var allcolBrama = $(".allcol_wrap:nth-child(3) .allcol_content .allcol_ct p:nth-child(2)").text();
  var allcolBlanc = $(".allcol_wrap:nth-child(5) .allcol_content .allcol_ct p:nth-child(2)").text();
  var cpcolGlorio = $(".allcol_wrap:nth-child(2) .allcol_content .allcol_ct p:nth-child(2)").text();
  var contactfile = $(".contactus-page .contact_rt #contactFormWrapper p.file_notice").text();
  
  
  // all collections
  $("#all-collections.mobile .allcol_wrap:nth-child(3) .allcol_content .allcol_ct p:nth-child(2)").text(allcolBrama);
  $("#all-collections.mobile .allcol_wrap:nth-child(5) .allcol_content .allcol_ct p:nth-child(2)").text(allcolBlanc);
  
  // cp collections
  $("#cosa-piora-collection.tablet .allcol_wrap:nth-child(2) .allcol_content .allcol_ct p:nth-child(2)").text(cpcolGlorio);
  $("#lapel-flower.mobile .breadcrumb-wrap .breadcrumb .breadcrumb_description p:first-child").html(allcol);
  $("#bravado.mobile .breadcrumb-wrap .breadcrumb .breadcrumb_description p:first-child").html(bravado);
  $("#cosa-blanc.mobile .breadcrumb-wrap .breadcrumb .breadcrumb_description p:first-child").html(blanc);
  $("#terms-amp-conditions.mobile .breadcrumb-wrap .breadcrumb .breadcrumb_position h2").html(terms);
  $("#privacy-amp-cookies.mobile .breadcrumb-wrap .breadcrumb .breadcrumb_position h2").html(privacy);

  $("#rispetto.mobile .breadcrumb-wrap .breadcrumb .breadcrumb_description p:last-child").html(rispetto);
  

  
  // pc
  $("#glorio .breadcrumb-wrap .breadcrumb .breadcrumb_description p:last-child").html(glorio);
  $("#cosa-brama .breadcrumb-wrap .breadcrumb .breadcrumb_description p:last-child").html(brama);
  $("#cosa-blanc .breadcrumb-wrap .breadcrumb .breadcrumb_description p:last-child").html(blanc2);
  
}




function wkSignin(){
  $('.wk-signin').click(function(){
    if(!$(this).hasClass("mobile")){
      $(".mycp-container").addClass('active');
      $('.wrapper-container').addClass('show-cp');
      $('body').css( "overflow", "hidden" );
    }
  });
}




function textReplace(){
  var crumbTerms,
      crumbSize,
      crumbStyle,
      crumbKorea,
      crumbCCPA,
      crumbPress,
      footerNews,
      footerNewsSuccess,
      contactFile,
      contactUs,
      cartAgree,
      cartOutof,
      productDetail,
      registerNews,
      myOrder,
      myAccount,
      wishSuccess;

  function textChange(){
    var windowsize = $(window).width();
    registerNews = $("#customer-fields .cp_newsletter").html();
    
    // pc -----------------------------------------------------------------
    if(windowsize > 1080){
      $("body").addClass("c_pc").removeClass("c_ta c_ta_port c_mo");
      $(".breadcrumb-wrap .breadcrumb .breadcrumb_description p:nth-child(1) br").remove();
      
      // contact us
      contactFile = "※ Images or files cannot be uploaded separately, therefore, please upload all Images or files at once.";              
    }

    // tablet all ---------------------------------------------------------
    if(windowsize < 1081 && windowsize > 767){
      $("body").addClass("c_ta").removeClass("c_pc c_ta_port c_mo");
      // contact us
      contactFile = "※ Images or files cannot be uploaded separately. please upload all Images or files at once.";
    }
    
    // tablet portrait ----------------------------------------------------
    if(windowsize < 1024 && windowsize > 767){
      $("body").addClass("c_ta_port").removeClass("c_pc c_mo");
      
      // newsletter popup
     // $("#popup-newsletter .newsletter-popup .newsletter-content .message br").remove();
     // $("#popup-newsletter .newsletter-popup .newsletter-content .sub-title").html("We provide the best handcrafted products that<br/>are combined with aesthetics and flexibility.<br/>It is up to you as to how you can benefit from them.<br/>Join us to be the first to find out!");
      
      // footer newsletter
      footerNews = "STAY CONNECTED TO OUR LATEST UPDATES AND OFFERS";
      
      // product
      productDetail = "Hand crafted box with golden graphics<br>(Double box: Outer & Inner)";
    }else{
       // breadcrumb
      
      // footer newsletter
      footerNews = "STAY CONNECTED TO OUR LATEST OFFERS";
      
      // product
      productDetail = "Hand crafted box with golden graphics (Double box: Outer & Inner)";
    }

    // mobile -------------------------------------------------------------
    if(windowsize < 768){
      $("body").addClass("c_mo").removeClass("c_pc c_ta c_ta_port");
      //newsletter popup
      $("#popup-newsletter .newsletter-popup .newsletter-content .title").html("RECEIVE 15% OFF<br>YOUR FIRST ORDER! ");
      $("#popup-newsletter .newsletter-popup .newsletter-content .sub").html("subscribe to receive<br>exclusive deals.")
      $("#popup-newsletter .newsletter-popup .newsletter-content .sub-title").html("Explore and experience the unique handcrafted masterpiece we offer.<br/>Start a journey with Cosa Piora.");
      $("#popup-newsletter .newsletter-popup .newsletter-content .policy").html("* Only valid with the first-time email used for submission.");
      $("#popup-newsletter .newsletter-popup .newsletter-content .message").html('I hereby agree and voluntarily grant my consent of processing of my personal data for personalization in the scope of the <a href="/pages/privacy-policy" target="_blank">Privacy Policy</a> provided by Cosa Piora.');
     
      // breadcrumb
      crumbTerms = 'Terms<span class="crumbsm">&amp;</span><br>Conditions';
      crumbKorea = 'Korea<br>Privacy Policy';
      crumbCCPA = 'CCPA<br>(California)';
      
      $("#all-collections .allcol_hd_txt p:first-child").html("The Final Touch to<br>your Bespoke Lifestyle");
      
      //var bdcrumb = 
      $(".breadcrumb-wrap .breadcrumb .breadcrumb_description p:nth-child(2) br").remove();
      $("#popup-newsletter .newsletter-popup .newsletter-content .message br").remove();
      //var newbdcrumb = bdcrumb.replace("<br>"," ")
        
      // contact us
      contactFile = "※ Please upload all Images or files at once.";
      contactUs = "YOUR SUBMISSION HAS BEEN RECEIVED.<br>WE WILL CONTACT YOU VERY SOON.<br>THANK YOU FOR CONTACTING US."
      
      // cart
      cartAgree = "YOU MUST AGREE WITH THE<br>TERMS &amp; CONDITIONS, SHIPPING, AND RETURN POLICY OF SALES TO PROCEED.";
      cartOutof= "To ensure the accuracy of items in your Shopping Bag, please remove “Out-of-Stock” products.";

      // account
      myOrder = "Check the status for your orders.";
      myAccount = "Manage your personal information<br>and Email preferences.";
      
      // register
      registerNews = "BY REGISTERING, YOU AGREE TO OUR COSA PIORA ACCOUNT <a class='cp_registerlink' href='/pages/term-condition' target='_blanc'>TERMS &amp; CONDITIONS</a> and <a class='cp_registerlink' href='/pages/privacy-policy' target='_blanc'>PRIVACY POLICY</a>."

      // wishlist
      wishSuccess = "Product successfully<br>added to your wishlist."
 
      // footer
//       footerNewsSuccess = "A confirmation email has been sent to verify."
      
      // 
      
      
    }else{
      // breadcrumb
      crumbTerms = 'Terms <span class="crumbsm">&amp;</span> Conditions';
      crumbKorea = 'Korea Privacy Policy';
      crumbCCPA = 'CCPA (California)';
      
      $("#popup-newsletter .newsletter-popup .newsletter-content .sub-title").html("WE PROVIDE THE BEST HANDCRAFTED PRODUCTS THAT ARE<br>COMBINED WITH AESTHETICS AND FLEXIBILITY. IT IS ENTIRELY<br>UP TO YOU AS TO HOW YOU CAN BENEFIT FROM THEM.<br>Join us to be the first to find out!");
       $("#popup-newsletter .newsletter-popup .newsletter-content .sub br").remove();

      $("#all-collections .allcol_hd_txt p:first-child").html("The Final Touch to your Bespoke Lifestyle");
      
      // contact us
      contactUs = "YOUR INQUIRY HAS BEEN SUBMITTED SUCCESSFULLY.<br>AFTER CAREFUL REVIEW, A REPSONSE WILL BE SENT TO YOU.<br>WE THANK YOU FOR YOUR TIME AND PATIENCE."
      
      // cart
      cartAgree = "YOU MUST AGREE WITH THE TERMS &amp; CONDITIONS,<br>SHIPPING, AND RETURN POLICY OF SALES TO PROCEED.";
      cartOutof= "To ensure the accuracy of items in your Shopping Bag,<br>please remove “Out-of-Stock” products.";

      // account
      myOrder = "Check the status for your orders or past orders.";
      myAccount = "Manage your personal information and Email preferences.";

      // wishlist
      wishSuccess = "Product successfully added to your wishlist."

      // register
      registerNews = "BY REGISTERING, YOU AGREE TO OUR COSA PIORA ACCOUNT<br><a class='cp_registerlink' href='/pages/term-condition' target='_blanc'>TERMS &amp; CONDITIONS</a> and <a class='cp_registerlink' href='/pages/privacy-policy' target='_blanc'>PRIVACY POLICY</a>."


      // footer
//       footerNewsSuccess = "A confirmation email has been sent to verify."

    }

    
    // ----------------------------------------------------------------------
   
    var bodyId = $("body").attr("id");
    
    
    switch (bodyId) {
      case "contact-us" : 
        $("#contact-us .file_notice").html(contactFile);
        $("#contact-us .contact_notice .notice_ms_wrap p").html(contactUs);
        break;
      case "your-shopping-bag" : 
        $(".notice_ms p.carts").html(cartAgree);
        $(".notice_ms p.out-of").html(cartOutof);
        break;
      case "create-account" :
        $(".cp_newsletter").html(registerNews);
        break;
      case "account" :
        $(".account_wrap .account_welcom.account_order p").html(myOrder);
        $(".account_wrap .account_welcom.account_myaccount p").html(myAccount);
        break;
      case "terms-amp-conditions":
        $(".breadcrumb-wrap .breadcrumb .breadcrumb_position h2").html(crumbTerms);
        break;
      case "korea-privacy-policy":
        $(".breadcrumb-wrap .breadcrumb .breadcrumb_position h2").html(crumbKorea);
        break;
      case "ccpa-california":
        $(".breadcrumb-wrap .breadcrumb .breadcrumb_position h2").html(crumbCCPA);
        break;
        
    }

    if($("body").hasClass("template-product")){
      if(bodyId.indexOf("gift-card")!== -1){
        //E-GIFT CARD USAGE
        var accor1 = "<p style='font-family: TimesNRMTStd-Regular'>E-Gift Cards can only be used on cosapiora.com. The E-Gift Card recipient will receive a one-of-a-kind code that can be used to purchase any product. You need to enter the code in the “Discount code or Gift card” box at the checkout page to redeem a specific offer. Refund is made back to your E-Gift Card as credit. It may not be exchanged for cash or taken as deposits.</p>";
        
        //TERMS & CONDITIONS
        var accor2 = "<p></p><p><span>Please note that the terms and conditions will apply to your purchase and the use of both our physical and E-Gift Cards.</span></p>";

        //DATE OF EXPIRATION
        var accor3 = "<p></p><p><span>There is no expiration date for the E-Gift Cards. However, promotional E-Gift Cards will have expiration dates of up to 1 year. The issued date can be found on the gift card email that was given at the point of purchase.</span></p>";
        
        // title
        $(".product_detail_wrap #accordion2 .panel.panel-default.accor_1 a span").text("E-GIFT CARD USAGE");
        $(".product_detail_wrap #accordion2 .panel.panel-default.accor_2 a span").text("TERMS & CONDITIONS");
        $(".product_detail_wrap #accordion2 .panel.panel-default.accor_3 a span").text("DATE OF EXPIRATION");

        // text
        $(".product_detail_wrap #accordion2 .panel.panel-default.accor_1 .panel-collapse .detail_wrap").html(accor1);
        $(".product_detail_wrap #accordion2 .panel.panel-default.accor_2 .panel-collapse .detail_wrap").html(accor2);
        $(".product_detail_wrap #accordion2 .panel.panel-default.accor_3 .panel-collapse .detail_wrap").html(accor3);
     
      
      }else{
        $(".product_detail_wrap #accordion2 .panel-default:nth-child(3) .panel-collapse .right_wrap p:nth-child(2) span:nth-child(2)").html(productDetail);
        }
    }

    
    $(".footer-container .footer-top .home-newsletter .title_newsletter").text(footerNews);
//     $(".notice_ms p.news").html(footerNewsSuccess);
    $(".notice_ms p.wk_success").html(wishSuccess);
        $(".notice_ms p.out-of").html(cartOutof);
    // --------------------------------------------------------------------
  }
  
  // Execute on load
  textChange();
  // Bind event listener
  $(window).resize(textChange);


}

function footer(){
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
  {
  }else{
    var $window = $(window);
    /* footer */
    var $child = $(".footer-top .footer-top-col-group .row > div");

    $child.eq(0).before("<div class='footer_group footer_forpc row'></div>");
    var $group = $(".footer_group");

    var i;
    for (i=0; i<4; i++){
      $child.eq(i).appendTo($group);
    }

    $child.eq(4).before("<div class='footer_group2 footer_forpc'></div>");
    var $group2 = $(".footer_group2");
    var j;
    for (j=4; j<7; j++){
//     for (j=4; j<6; j++){
      $child.eq(j).appendTo($group2);
    }


    function checkWidth() {
      var windowsize = $window.width();

      if($(".sub_nav li").length > 0){
        //$(".link_cosapiora").removeClass("highlight")
      }

      // tablet portrait ----------------------------------------------------
      if(windowsize < 1080 && windowsize > 767){
        $(".footer_forpc").addClass("col-6");

        $(".social-icon-wrap").addClass("col-4");
        $(".changemode").addClass("col-4");

        if($(".sub_nav li").length > 0){
          $(".link_cosapiora").addClass("highlight")
        }
        
        var $height = $(".menu_footer_wrapper:nth-child(2)").outerHeight();
        $(".newsletter_wrap").css("height",$height);

      }else{
        $(".footer_forpc").removeClass("col-6 col-12");

        $(".social-icon-wrap").removeClass("col-4");
        $(".changemode").removeClass("col-4");
        
         $(".newsletter_wrap").css("width","100%");

      }

      // mobile -------------------------------------------------------------
      if(windowsize < 768){
        $(".menu_footer_wrapper").addClass("col-6");
        $(".footer_forpc").addClass("col-12");
        $(".footer_group2").addClass("row");

//         $(".newsletter_wrap").insertAfter(".changemode.topc").addClass("col-12");
        $(".social-icon-wrap").insertBefore(".newsletter_wrap").addClass("col-6");
        $(".changemode").addClass("col-6");


        // careers
        $(".careers_content").removeClass("row");

        if($(".sub_nav li").length > 0){
          $(".link_cosapiora").addClass("highlight")
        }

      }else{
        $(".menu_footer_wrapper").removeClass("col-6");
        $(".footer_forpc").removeClass("col-12");
        $(".footer_group2").removeClass("row");

//         $(".newsletter_wrap").insertBefore(".social-icon-wrap").removeClass("col-12");;
        $(".social-icon-wrap").removeClass("col-6");
        $(".changemode").removeClass("col-6");

        // careers
        $(".careers_content").addClass("row");
      }

      // --------------------------------------------------------------------

    }
    // Execute on load
    checkWidth();
    // Bind event listener
    $(window).resize(checkWidth);


  }
  return false;

}

function changemode(){
  // if(getCookie("DesktopMode") == "true"){
  //   $("#changemode").addClass("intablet");
  // }
}